import styled from 'styled-components';
import { colorCSS, fontSizes } from '../../styles';
export const Footer = styled.footer `
  font-size: ${fontSizes.xs};
  margin: 1.25rem 0;

  select {
    border: 2px solid ${colorCSS('N30')};
    color: ${colorCSS('N300')};
    padding: 0.25rem 0.5rem;
    background-position: center right 0.5rem;
    margin: 1rem auto 0.5rem;
  }

  svg {
    color: ${colorCSS('B400')};
    display: block;
    margin: 1.25rem auto;
    width: 150px;
  }

  .tagline p {
    color: ${colorCSS('N400')};
    margin: 1rem 0 0;
  }
`;
export const Links = styled.nav `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  a,
  button {
    color: ${colorCSS('N300')};
    padding: 0.125rem 0.75rem;
    text-decoration: none;
    &:hover {
      color: ${colorCSS('N400')};
      text-decoration: underline;
    }
  }
`;
//# sourceMappingURL=UiFooterNavBasic.styles.js.map